/** Phone-sized viewport; matches the SCSS $breakpoint-mobile value. */
export const MOBILE_BREAKPOINT = 768

/**
 * Below this width there isn't room for a persistent side panel alongside
 * content — matches the SCSS $breakpoint-tablet value. Below it, navigation
 * chrome should take over the full screen (the mobile pattern), not squeeze
 * into a half-visible sidebar.
 */
export const NARROW_BREAKPOINT = 1024
